"use strict";

var _slicedToArray = require("/home/runner/work/react-nexys-boilerplate/react-nexys-boilerplate/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var prop_types_1 = __importDefault(require("prop-types"));

var form_1 = __importDefault(require("../data/form"));

var ListCrud = function ListCrud(props) {
  var ListUI = props.ListUI,
      FormUI = props.FormUI,
      promise = props.promise,
      _props$initData = props.initData,
      initData = _props$initData === void 0 ? [] : _props$initData,
      restOfProps = __rest(props, ["ListUI", "FormUI", "promise", "initData"]);

  var _react_1$default$useS = react_1.default.useState(initData),
      _react_1$default$useS2 = _slicedToArray(_react_1$default$useS, 2),
      listData = _react_1$default$useS2[0],
      setListData = _react_1$default$useS2[1];

  var _react_1$default$useS3 = react_1.default.useState(null),
      _react_1$default$useS4 = _slicedToArray(_react_1$default$useS3, 2),
      formData = _react_1$default$useS4[0],
      setFormData = _react_1$default$useS4[1];

  var handleDelete = function handleDelete(uuid) {
    setListData(listData.filter(function (_) {
      return _.uuid !== uuid;
    }));
  };

  var handleAdd = function handleAdd() {
    setFormData({});
  };

  var handleUpdate = function handleUpdate(d, resultFromBackend) {
    if (!d.id) {
      var e = listData.concat([Object.assign(Object.assign({}, d), resultFromBackend)]);
      setListData(e);
      return;
    }

    setListData(listData.map(function (x) {
      if (x.uuid === d.id) {
        return d;
      }

      return x;
    }));
  };

  if (formData === null) {
    return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(ListUI, Object.assign({
      data: listData,
      onClick: function onClick(d) {
        return setFormData(d);
      },
      onDelete: handleDelete
    }, restOfProps)), react_1.default.createElement("button", {
      onClick: handleAdd
    }, "Add"));
  }

  return react_1.default.createElement(form_1.default, {
    UI: FormUI,
    data: formData,
    promise: promise,
    onUpdate: handleUpdate,
    onToggle: function onToggle() {
      return setFormData(null);
    }
  });
};

ListCrud.propTypes = {
  ListUI: prop_types_1.default.node.isRequired,
  FormUI: prop_types_1.default.node.isRequired,
  promise: prop_types_1.default.shape({
    then: prop_types_1.default.func,
    catch: prop_types_1.default.func
  }).isRequired,
  initData: prop_types_1.default.array
};
exports.default = ListCrud;